export default "__VITE_ASSET__79550cce__"